import { LocationService } from '../services';

const namespace = 'locations';

export const FETCHING_LOCATIONS = `${namespace}/FETCHING_LOCATIONS`;
export const RECEIVE_LOCATIONS = `${namespace}/RECEIVE_LOCATIONS`;

export const SAVING_LOCATION = `${namespace}/SAVING_LOCATION`;
export const LOCATION_SAVED = `${namespace}/LOCATION_SAVED`;

export function getLocations() {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchingLocations());
    return LocationService.getAll(state.auth.auth).then((locations) => {
      return dispatch(receiveLocations(locations));
    });
  }
}

export function fetchingLocations() {
  return {
    type: FETCHING_LOCATIONS
  };
}

export function receiveLocations(locations) {
  return {
    type: RECEIVE_LOCATIONS,
    locations
  }
}

export function saveLocation(location) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(savingLocation());
    return LocationService.save(state.auth.auth, location).then((savedLocation) => {
      dispatch(locationSaved(savedLocation));
      return dispatch(getLocations());
    });
  }
}

export function savingLocation() {
  return {
    type: SAVING_LOCATION
  };
}

export function locationSaved(location) {
  return {
    type: LOCATION_SAVED,
    location
  };
}

export function deleteLocation(locationId) {
  return (dispatch, getState) => {
    const state = getState();
    return LocationService.deleteLocation(state.auth.auth, locationId);
  }
}



// WEBPACK FOOTER //
// ./src/actions/LocationActions.js